import { Logo, Stack } from "../../components"
import { FlagPicker } from "../../language"
import { TypePicker } from "../../typePicker"
import { OtherWelcomePageComponent } from "./otherwelcomepage.component"

export const WelcomePage = () => {
  return (
    <Stack gap={20}>
      <Stack>
        <TypePicker />
      </Stack>
			<Stack>
				{/* <p>Dersom du ikke har legetime - trykk på resepsjon.</p> */}
			</Stack>
      <Stack>
        <OtherWelcomePageComponent />
        <FlagPicker />
      </Stack>
    </Stack>
  )
}